// DUPLICATED in @hoteltradergit/user-management — sync changes manually until the
// shared component lib (ht-component-library) absorbs both copies.
import React from "react";
import PropTypes from "prop-types";
import "./StatusToggle.scss";

const StatusToggle = ({
  checked,
  disabled,
  onChange,
  label,
  activeLabel = "Active",
  inactiveLabel = "Inactive",
  ariaLabel,
}) => {
  const _label = label || (checked ? activeLabel : inactiveLabel);
  // Optional override. The derived name is built from the visible label, which is fine when that label
  // is Active/Inactive but not when several toggles share one — a table of rows all announcing
  // "Toggle 3 days left status" gives a screen-reader user no way to tell them apart.
  const _ariaLabel = ariaLabel || `Toggle ${_label} status`;

  return (
    <div className="status-toggle-container">
      <label className={`status-toggle ${disabled ? "disabled" : ""}`}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          aria-label={_ariaLabel}
        />
        <span className="toggle-slider"></span>
      </label>
      <span className="toggle-label">{_label}</span>
    </div>
  );
};

StatusToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  activeLabel: PropTypes.string,
  inactiveLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default StatusToggle;
